import { useContext } from 'react';

import { VoiceMeetingContext } from 'features/voice-meeting/contexts';

export const useVoiceMeetingContext = () => {
  return useContext(VoiceMeetingContext);
};
